import { Link, useSearchParams } from "react-router-dom";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { Check, ArrowRight } from "lucide-react";

export default function ThankYou() {
  const [params] = useSearchParams();
  const bookingId = params.get("id");
  const price = params.get("price");

  return (
    <div data-testid="thank-you-page">
      <Nav theme="light" />
      <div className="sv-thanks">
        <div className="container-x" style={{ maxWidth: 680 }}>
          <div className="check"><Check size={36} strokeWidth={2.5} /></div>
          <span className="eyebrow eyebrow-navy">Booking received</span>
          <h1>Your sleep study is <span className="em-italic-navy">on its way.</span></h1>
          <p style={{ fontSize: 17, color: "var(--ink-60)", maxWidth: 520, margin: "0 auto 32px", lineHeight: 1.6 }}>
            Your request has been sent directly to the specialist&apos;s dashboard. They or their team will reach out to you within 24 hours to confirm your slot.
          </p>
          {bookingId && (
            <div style={{ display: "inline-block", padding: "14px 20px", background: "white", border: "1px solid var(--line)", borderRadius: 999, marginBottom: 28, fontFamily: "var(--font-mono)", fontSize: 12, color: "var(--ink-60)", letterSpacing: "0.1em" }}>
              Booking ID · <span style={{ color: "var(--navy)" }}>{bookingId.slice(0, 8).toUpperCase()}</span>
              {price && <> · ₹{parseInt(price).toLocaleString()}</>}
            </div>
          )}
          <div style={{ background: "rgba(78,205,196,0.08)", border: "1px solid rgba(78,205,196,0.3)", borderRadius: "var(--radius-lg)", padding: 24, textAlign: "left", marginBottom: 32 }}>
            <div className="eyebrow eyebrow-navy" style={{ color: "var(--teal)" }}>What&apos;s next</div>
            <ol style={{ marginTop: 14, paddingLeft: 20, fontSize: 14, color: "var(--navy)", lineHeight: 1.8 }}>
              <li>Your specialist receives your booking (and quiz results, if you took the quiz).</li>
              <li>Their team calls or messages you within 24 hours to confirm date, time, and any prep.</li>
              <li>Payment is handled directly by the clinic — Somveil does not collect payment yet.</li>
              <li>After your sleep study, you receive results from the lab within 48 hours.</li>
            </ol>
          </div>
          <div style={{ display: "flex", gap: 12, justifyContent: "center", flexWrap: "wrap" }}>
            <Link to="/" className="btn btn-ghost" data-testid="thanks-home-btn">Back to home</Link>
            <Link to="/doctors" className="btn btn-dark" data-testid="thanks-browse-btn">Browse more specialists <ArrowRight size={14} /></Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
